var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "client-devices" },
    [
      _c("el-card", [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("span", { staticClass: "header-item" }, [
              _vm._v(_vm._s(_vm.$t("customer_authorizations.title"))),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "ring-card__header-buttons" },
              [
                _c("RefreshButton", {
                  nativeOn: {
                    click: function ($event) {
                      return _vm.fetch()
                    },
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-content" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.ajax.working,
                    expression: "ajax.working",
                  },
                ],
                staticClass: "client-device-table",
                attrs: { data: _vm.authorizations },
              },
              _vm._l(_vm.metaTable, function (column) {
                return _vm.showColumn({ id: column.id })
                  ? _c("el-table-column", {
                      key: column.prop,
                      attrs: { prop: column.prop, label: column.label },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                column.prop === "status"
                                  ? _c("section", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getStatusValue(scope.row)
                                          ) +
                                          "\n\n              "
                                      ),
                                      scope.row.auth_type === "tiv"
                                        ? _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "loading",
                                                  rawName: "v-loading",
                                                  value: _vm.get(
                                                    scope.row,
                                                    "refreshingStatus",
                                                    false
                                                  ),
                                                  expression:
                                                    "get(scope.row, 'refreshingStatus', false)",
                                                },
                                              ],
                                              on: {
                                                click: function ($event) {
                                                  _vm.updateStatus({
                                                    id: _vm.get(
                                                      scope.row,
                                                      "id",
                                                      ""
                                                    ),
                                                  })
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(
                                                    _vm.$t("common.refresh")
                                                  ) +
                                                  ") "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _c("section", [
                                      column.date
                                        ? _c(
                                            "span",
                                            [
                                              _c("time-zone-formatter", {
                                                attrs: {
                                                  "current-time": _vm.get(
                                                    scope.row,
                                                    column.prop,
                                                    ""
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.get(
                                                    scope.row,
                                                    column.prop,
                                                    ""
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e()
              }),
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }